"use client";

const navigationTabs = [
  { name: "Dashboard", href: "/" },
  { name: "My Tasks", href: "/my-tasks" },
  { name: "Projects", href: "/projects" },
  { name: "HOD Collaboration", href: "/hod-collaboration" },
  { name: "Time Management", href: "/time-management" },
  // Expenses, Invoices, Estimates and Clients are intentionally hidden.
];

export default function Navigation({ currentPage, onNavigate }) {
  const handleTabClick = (tabName) => {
    if (onNavigate) {
      onNavigate(tabName); // Tell parent to update the active tab
    }
  };

  return (
    <div className="productivity-tabs grid w-full min-w-0 grid-cols-2 gap-2 sm:flex sm:overflow-x-auto sm:pb-3 md:gap-4 lg:gap-1">
      {navigationTabs.map((tab) => {
        const isActive = currentPage === tab.name;

        return (
          <button
            key={tab.name}
            onClick={() => handleTabClick(tab.name)}
            className={`min-h-12 min-w-0 rounded-lg px-3 py-2 text-sm font-medium transition-colors sm:min-h-0 sm:shrink-0 sm:px-4 ${
              isActive
                ? "bg-blue-600 text-white"
                : "bg-white text-gray-600 hover:bg-gray-100"
            }`}
          >
            {tab.name}
          </button>
        );
      })}
    </div>
  );
}
